import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import alerts from './alerts'
import archivedStudies from './archivedStudies'
import boxTranscriptProducts from './boxTranscriptProducts'
import brandings from './brandings'
import clips from './clips'
import companies from './companies'
import company from './company'
import companyRoles from './companyRoles'
import currentUser from './currentUser'
import documentSessions from './documentSessions'
import emailDomains from './emailDomains'
import entities from './entities'
import features from './features'
import highlights from './highlights'
import modals from './modals'
import permissions from './permissions'
import projects from './projects'
import reports from './reports'
import responses from './responses'
import roles from './roles'
import { routerReducer as routing } from 'react-router-redux'
import searches from './searches'
import searchResults from './searchResults'
import studyPermissions from './studyPermissions'
import transcriptionKey from './transcriptionKey'
import transcriptionTranscriptRequests from './transcriptionTranscriptRequests'
import studiesWithTranscriptsOrdered from './studiesWithTranscriptsOrdered'
import users from './users'
import workspaces from './workspaces'
import videoPlayers from './videoPlayers'
import taniState from './taniState'

export default combineReducers({
  alerts,
  archivedStudies,
  boxTranscriptProducts,
  brandings,
  clips,
  companies,
  company,
  companyRoles,
  currentUser,
  documentSessions,
  entities,
  emailDomains,
  features,
  form,
  highlights,
  modals,
  permissions,
  projects,
  responses,
  reports,
  roles,
  routing,
  searches,
  searchResults,
  studiesWithTranscriptsOrdered,
  studyPermissions,
  transcriptionKey,
  transcriptionTranscriptRequests,
  users,
  workspaces,
  videoPlayers,
  taniState 
})



// WEBPACK FOOTER //
// ../src/reducers/index.js